import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { getUser } from '../../actions/profiles/usersActions'
import { dashboardAdmin } from '../../actions/payments/paymentActions'
import { Link } from 'react-router-dom'
import Version from '../../version'

export default function Dashboard() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
	const {clientauth} = useAuth()

    const [totalQuantity,setTotalQuantity]= useState(0)
    const [totalRawQuantity,setTotalRawQuantity]= useState(0)
    const [totalRefunded,setTotalRefunded]= useState(0)
    const [totalBenefit,setTotalBenefit]= useState(0)
    const {user} = useSelector(state=>state.users)
    const {resume} = useSelector(state=>state.payment)

    const formatNumber = (num) => {
        return new Intl.NumberFormat('es-ES', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num)
    }

    useEffect(() => {
        if(clientauth){
            dispatch(getUser(clientauth?.id))
            dispatch(dashboardAdmin())
        }
    },[dispatch, t, clientauth])
    useEffect(()=>{
        if(resume){
            setTotalQuantity(parseFloat(resume.totalQuantity) || 0)
            setTotalRawQuantity(parseFloat(resume.totalRawQuantity) || 0)
            setTotalRefunded(parseFloat(resume.totalRefunded) || 0)
            setTotalBenefit(parseFloat(resume.totalBenefit) || 0)
        }
    },[resume])

    return (
        <Container className='cuerpo'>
            <div className='welcome-banner'>
                <div className='welcome-content'>
                    <span className='welcome-label'>{t('admin.dashboard.welcome')}</span>
                    <h1 className='welcome-title'>{user?.username}</h1>
                    <p className='welcome-subtitle'>{t('admin.dashboard.subwelcome')}</p>
                </div>
                <div className='welcome-icon'>
                    <i className="fas fa-user-shield"></i>
                </div>
            </div>

            <Row className='g-4 mb-5'>
                <Col xs={6} lg={3}>
                    <div className='kpi-card'>
                        <div className='kpi-header'>
                            <div>
                                <div className='kpi-value'>{formatNumber(parseFloat(totalQuantity.toString().replace(',', '.')) || 0)} €</div>
                                <div className='kpi-label'>{t('admin.dashboard.revenue') || 'Ingresos'}</div>
                            </div>
                            <div className='kpi-icon teal'>
                                <i className="fas fa-euro-sign"></i>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col xs={6} lg={3}>
                    <div className='kpi-card'>
                        <div className='kpi-header'>
                            <div>
                                <div className='kpi-value'>{formatNumber(parseFloat(totalRawQuantity.toString().replace(',', '.')) || 0)} €</div>
                                <div className='kpi-label'>{t('admin.dashboard.clubs') || 'Clubes'}</div>
                            </div>
                            <div className='kpi-icon navy'>
                                <i className="fas fa-building"></i>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col xs={6} lg={3}>
                    <div className='kpi-card'>
                        <div className='kpi-header'>
                            <div>
                                <div className='kpi-value'>{formatNumber(parseFloat(totalBenefit.toString().replace(',', '.')) || 0)} €</div>
                                <div className='kpi-label'>{t('admin.dashboard.margin') || 'Margen'}</div>
                            </div>
                            <div className='kpi-icon green'>
                                <i className="fas fa-chart-line"></i>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col xs={6} lg={3}>
                    <div className='kpi-card'>
                        <div className='kpi-header'>
                            <div>
                                <div className='kpi-value'>{formatNumber(parseFloat(totalRefunded.toString().replace(',', '.')) || 0)} €</div>
                                <div className='kpi-label'>{t('admin.dashboard.refunds') || 'Devoluciones'}</div>
                            </div>
                            <div className='kpi-icon orange'>
                                <i className="fas fa-undo"></i>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

            <div className='section-title'>
                <h2>{t('admin.dashboard.quickAccess') || 'Acceso rápido'}</h2>
            </div>
            <Row className='g-4'>
                <Col xs={12} sm={6} lg={3}>
                    <Link to={`/${t("url.admin.admin")}/${t("url.admin.clubs")}`} className='text-decoration-none'>
                        <div className='nav-card-action'>
                            <div className='nav-card-icon teal'>
                                <i className="fas fa-building"></i>
                            </div>
                            <div className='nav-card-info'>
                                <h3>{t('superadmin.dashboard.clubs')}</h3>
                                <p>{t('admin.dashboard.manageClubs') || 'Gestionar clubes'}</p>
                            </div>
                            <i className="fas fa-chevron-right nav-card-arrow"></i>
                        </div>
                    </Link>
                </Col>
                <Col xs={12} sm={6} lg={3}>
                    <Link to={`/${t("url.admin.admin")}/${t("url.admin.clients")}`} className='text-decoration-none'>
                        <div className='nav-card-action'>
                            <div className='nav-card-icon navy'>
                                <i className="fas fa-users"></i>
                            </div>
                            <div className='nav-card-info'>
                                <h3>{t('superadmin.dashboard.clients')}</h3>
                                <p>{t('admin.dashboard.manageClients') || 'Gestionar clientes'}</p>
                            </div>
                            <i className="fas fa-chevron-right nav-card-arrow"></i>
                        </div>
                    </Link>
                </Col>
                <Col xs={12} sm={6} lg={3}>
                    <Link to={`/${t("url.admin.admin")}/${t("url.admin.inscriptions")}`} className='text-decoration-none'>
                        <div className='nav-card-action'>
                            <div className='nav-card-icon green'>
                                <i className="fas fa-calendar-check"></i>
                            </div>
                            <div className='nav-card-info'>
                                <h3>{t('superadmin.dashboard.inscriptions')}</h3>
                                <p>{t('admin.dashboard.manageInscriptions') || 'Gestionar inscripciones'}</p>
                            </div>
                            <i className="fas fa-chevron-right nav-card-arrow"></i>
                        </div>
                    </Link>
                </Col>
                <Col xs={12} sm={6} lg={3}>
                    <Link to={`/${t("url.admin.admin")}/${t("url.admin.payments")}`} className='text-decoration-none'>
                        <div className='nav-card-action'>
                            <div className='nav-card-icon orange'>
                                <i className="fas fa-credit-card"></i>
                            </div>
                            <div className='nav-card-info'>
                                <h3>{t('superadmin.dashboard.payments')}</h3>
                                <p>{t('admin.dashboard.managePayments') || 'Gestionar pagos'}</p>
                            </div>
                            <i className="fas fa-chevron-right nav-card-arrow"></i>
                        </div>
                    </Link>
                </Col>
            </Row>
            <Row>
                <Col className='text-center mt-5'>
                    <Version />
                </Col>
            </Row>
        </Container>
    )
}
